<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <p [innerHTML]="message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end" cdkTrapFocus>
  <button mat-button mat-dialog-close type="button">Zrušit</button>
  <button color="primary" mat-flat-button (click)="dialogRef.close(true)">
    {{ confirmText }}
  </button>
</mat-dialog-actions>
